module.exports = __webpack_public_path__ + "img/glass-rocks.283f370d.svg";